export default __webpack_public_path__ + "static/media/h510.415f7398.jpg";